<template>
  <v-row dense>
    <v-col cols="12">
      <v-card text>
        <div class="d-flex flex-no-wrap justify-space-between" @click="toggleVoting" :ripple="false" flat>
          <v-avatar
            class="my-2"
            size="90"
            tile
          >
          <RatingItemImage :systembolagetNr="beer.systembolagetNr" />
          </v-avatar>
          <div class="d-flex space-around flex-column justify-space-between">
            <div>
              <v-card-title class="caption font-weight-bold mb-0 pl-0 pb-0">
                {{ beer.name }}
              </v-card-title>
              <BeerCardDetails :systembolagetNr="beer.systembolagetNr" />
            </div>
            <v-btn class="ma-0 pa-0" x-small text v-if="!showVoting">
              Rösta <v-icon left>mdi-menu-down</v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-center text-center mr-2">
            <v-rating-circle :average="beer.average"/>
          </div>
        </div>
        <v-expand-transition>
          <div class="mx-2 mt-5 pt-5" v-if="showVoting">
            <v-slider
                v-model="value"
                step="5"
                ticks="always"
                tick-size="2"
                thumb-label="always"
                thumb-size="40"
                @click:append="voteDown"
                @click:prepend="voteUp"
                append-icon="mdi-plus-circle-outline"
                prepend-icon="mdi-minus-circle-outline"
                class="my-5 py-5"
                hint="Sätt betyg genom att använda reglagen ovan."
                persistent-hint
              >
              <template v-slot:thumb-label>
                {{ voteComputed }}
              </template>
            </v-slider>
            <div class="d-flex justify-space-between pb-2 align-baseline">
              <v-btn @click="toggleVoting" text small>
                Stäng<v-icon right small>mdi-close</v-icon>
              </v-btn>
              <v-btn @click="vote" color="success" :disabled="value < 1">
                Rösta<v-icon right>mdi-check</v-icon>
              </v-btn>
            </div>
          </div>
        </v-expand-transition>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import VRatingCircle from '../VRatingCircle'
import BeerCardDetails from '../beers/BeerCardDetails'
import RatingItemImage from './RatingItemImage'

export default {

  components: {
    VRatingCircle,
    BeerCardDetails,
    RatingItemImage,
  },
  props: {
    beer: {
      required: true
    }
  },
  data () {
    return {
      showVoting: false,
      value: 0
    }
  },
  computed: {
    voteComputed () {
      return this.calculcateVoteScore(this.value)
    }
  },
  methods: {
    calculcateVoteScore (value) {
      return (value * 5) / 100
    },
    toggleVoting () {
      this.showVoting = !this.showVoting
    },
    voteUp () {
      this.value = (this.value - 5) || 0
    },
    voteDown () {
      this.value = (this.value + 2.5) || 100
    },
    vote () {
      let rateData = {}
      // Get slider value
      rateData.rating = this.calculcateVoteScore(this.value)
      rateData.dateKey = this.$store.getters.dateKey
      rateData.beerId = this.beer.id
      rateData.name = this.$store.getters.raterName

      // Save rating to Firebase
      this.$store.dispatch('addRating', rateData)
      this.toggleVoting()
    }
  }
}
</script>
